import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { FaUser, FaEnvelope, FaLock, FaIdCard, FaPhone } from 'react-icons/fa';
import '../styles/Auth.css';

const Signup = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    fullName: '',
    enrollmentId: '',
    contact: ''
  });

  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateStep1 = () => {
    if (!formData.enrollmentId.trim()) {
      toast.error('Please enter your Enrollment ID');
      return false;
    }
    if (!formData.email.trim()) {
      toast.error('Please enter your email');
      return false;
    }
    if (!formData.contact.trim()) {
      toast.error('Please enter your contact number');
      return false;
    }
    return true;
  };

  const validateStep2 = () => {
    if (!formData.fullName.trim()) {
      toast.error('Please enter your full name');
      return false;
    }
    if (!formData.password.trim()) {
      toast.error('Please enter password');
      return false;
    }
    if (formData.password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return false;
    }
    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match');
      return false;
    }
    return true;
  };

const handleNext = async () => {
  if (!validateStep1()) return;

  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/admission/check`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        enrollmentId: formData.enrollmentId,
        email: formData.email,
        contact: formData.contact
      })
    });

    const data = await response.json();

    if (!data.success) {
      toast.error("Invalid Enrollment ID or details do not match our records");
      return;
    }

    toast.success("Enrollment verified successfully");
    setStep(2);

  } catch (error) {
    console.error(error);
    toast.error("Something went wrong. Try again.");
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateStep2()) return;

    setLoading(true);

    // SEND ONLY CLEAN JSON EXPECTED BY BACKEND
    const cleanData = {
      email: formData.email,
      password: formData.password,
      fullName: formData.fullName,
      contact: formData.contact
    };

    const result = await register(cleanData);

    if (result.success) {
      toast.success('Account created successfully!');
      navigate('/student');
    } else {
      toast.error(result.message);
    }

    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-container">

        <div className="auth-card">
          <div className="auth-header">
            <h2>Create Student Account</h2>
            <p>Link your admission to access dashboard</p>
          </div>

          <div className="step-indicator">
            <div className={`step ${step >= 1 ? 'active' : ''}`}>
              <span>1</span>
              <p>Verify Details</p>
            </div>
            <div className={`step ${step >= 2 ? 'active' : ''}`}>
              <span>2</span>
              <p>Create Account</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">

            {step === 1 && (
              <>
                <div className="form-group">
                  <label><FaIdCard /> Enrollment ID *</label>
                  <input
                    type="text"
                    name="enrollmentId"
                    value={formData.enrollmentId}
                    onChange={handleChange}
                    required
                    placeholder="e.g., NEC24001"
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label><FaEnvelope /> Email Address *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Email used in admission form"
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label><FaPhone /> Contact Number *</label>
                  <input
                    type="tel"
                    name="contact"
                    value={formData.contact}
                    onChange={handleChange}
                    required
                    placeholder="WhatsApp number"
                    className="form-input"
                  />
                </div>

                <button 
                  type="button"
                  className="btn-primary btn-block"
                  onClick={handleNext}
                >
                  Verify & Continue
                </button>
              </>
            )}

            {step === 2 && (
              <>
                <div className="form-group">
                  <label><FaUser /> Full Name *</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                    placeholder="As per admission form"
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label><FaLock /> Password *</label>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    placeholder="Minimum 6 characters"
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label><FaLock /> Confirm Password *</label>
                  <input
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                    placeholder="Re-enter your password"
                    className="form-input"
                  />
                </div>

                <div className="form-actions">
                  <button type="button" className="btn-secondary" onClick={() => setStep(1)}>
                    Back
                  </button>
                  <button type="submit" className="btn-primary" disabled={loading}>
                    {loading ? 'Creating Account...' : 'Create Account'}
                  </button>
                </div>
              </>
            )}

          </form>

          <div className="auth-footer">
            <p>Already have an account? <Link to="/login">Login here</Link></p>
          </div>

        </div>

      </div>
    </div>
  );
};

export default Signup;
